import { editorPicks } from "@/mocks/movies";

export default function EditorPicksSection() {
  return (
    <section id="picks" className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="max-w-3xl">
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold">
          <i className="ri-award-line" aria-hidden="true" />
          编辑精选
        </span>
        <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          好看的片 · 值得一看的片单
        </h2>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
          从片库里挑出近期口碑最好的几部，每一部都附上挑选理由，
          没有长篇大论，只帮你判断「这部到底适不适合现在看」。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {editorPicks.map((p) => (
          <article
            key={p.id}
            className="group flex gap-4 rounded-xl bg-background-50 border border-background-200 p-4"
          >
            <div className="w-28 sm:w-32 shrink-0 aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src={p.poster}
                alt={`${p.title} 影片海报`}
                title={`${p.title} 在线观看 - 八戒影院`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-col min-w-0">
              <div className="flex items-center gap-2">
                <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-800 text-xs font-medium">
                  {p.tag}
                </span>
                <span className="text-xs font-bold text-foreground-800 flex items-center gap-1">
                  <i className="ri-star-fill text-primary-500 text-xs" aria-hidden="true" />
                  {p.rating}
                </span>
              </div>
              <h3 className="mt-2 text-base font-semibold text-foreground-950 group-hover:text-accent-600 transition-colors">
                {p.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{p.comment}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}